import { useEffect, useLayoutEffect, useRef, useState } from "react"
import { useForm } from "react-hook-form";
import { subscribe, useSnapshot } from "valtio"
import Api from "../state/Api"
import { AgmodalStore, bookingsStore, configStore, contractsStore, entityStore, EntityV2Store, filtersState, loginStore, quoteDataRec } from "../state/CommonState"
import { Cargo, Container, enquiryStore } from "../enquiry/enquiry-data"
import EnquiriesApi from "../state/enq-api"
import Utils from "../util/Utils"
import { CarrierWebView2v3 } from "./carrierweb-view-v3"
import { useGlobalState } from "../GlobalState"
import { AgInput } from "../components/AgComponents"
import MonApi, { GET_BOOKINGDSR_BY_FILTER_URI, GET_BOOKINGS_IDS_URI, GET_BOOKINGS_LIST_URI, GET_CARTING_ORDERS_BY_FILTER_URI, GET_CARTING_ORDERS_WITHOUT_FILES_URI, GET_MYACTIONS_UPDATE_COST_COMPLETED_URI, REMOVE_MYACTIONS_BY_BOOKING_NUMBER_AND_STATUS_URI, UPDATE_BOOKINGDSR_BY_ID_URI, UPDATE_BOOKING_FIELDS_URI } from '../state/mongo-api';
import TaskTrigger from "../mytasks/task-trigger"
import VendorAssignment from "../mytasks/vendor-assignment-form"
import { taskStore } from "../mytasks/task-store"
import Taskapi, { Task } from "../mytasks/tasks-api"
import Newapi from "../state/new-api"
import { myactionsstore } from "../my-actions/store-myactions"
import { Visibility } from "../my-actions/visibility"
import { VisibilityGraph } from "../my-actions/visibilitygraph"
import BookingSchedule from "../pricing/booking.schedule"
import RoleUtils from "../util/RoleUtils";
import { PERMISSIONS, PERMISSIONS_NEW , SHIPMENT_TYPE} from "../util/constants";
import ActrejectModal6 from "./enquirysuggestion-v3"
import CarrierWebView1v3 from "./carrierweb-view-v3"
import AguserApi from "../state/AguserApi"
import { Autocomplete, IconButton, Menu } from "@mui/material"
import EntityV2Api from "../state/entities-api"
import backarrow  from "../assets/images/backarrow.svg";
import { Route } from "../v3-componets/AgRoute";
import { Details } from "../v3-componets/AgDetails";
import { loader } from "../util/loader";
import BookingsApi from "../state/bookings-api";
import AgNewModal from "../components/AgnewModal";
import EntityUtils from "../util/entityUtils";
import LoadERP from "../erp/LoadERP"
import EntityApi from "../state/entity-api";
import FCLChargeClientViewv3 from "./FCLChargeClientView-v3";
import AirChargesClientViewv3 from "./AirChargesClientView-v3";
import LCLChargeClientViewv3 from "./LCLChargeClientView-v3";
import Taskfiledisplay from "../mytasks/task-file-display";
import { rtpStore } from "../pricing/pricing-store";
import { DsrModal } from "../my-actions/dsrmodal";
import ContractDetails from "../v3-componets/ContractDetails";
import CartingOrderApi from "../state/cartingorder-api";
import TenantUtils from "../util/tenant.utils";
import { BlLadingForm } from "../components/dashboard/blLadingForm";
import { Col3 } from "../Controls";
import on from '../components/on2.png';
import off from '../components/off.png';
import RazorpayRize from "../mui-components/RazorpayRize";
import PricingUtils from "../pricing/pricing.utils";
import filtericon from "../assets/images/filterfilled.svg"
import { QuickQuoteFilters } from "../mui-components/QuickQuoteFilters";
import SpotLCLDisplayv3 from "../quick-quotev3/spot.lcl.display-v3";
import SpotFCLDisplayv3 from "../quick-quotev3/spot.fcl.display-v3";
import SpotAirDisplayv3 from "../quick-quotev3/spot.air.display-v3";
import { CustomStyledTextField } from "../mui-components/ColoredTextfield";
import BranchApi from "../state/branch-api";
import QuoteCalcV2 from "../util/quote-calc-v2";
import { AgWarnPopup } from "../components/AgCustomComponents";
import { getPayload } from "../mytasks/tasks-static-data";
import { masterjobStore, resetMasterJobStore } from "../masterJob/masterjobStore";


function RoutesEmpty({ message}) {
    useSnapshot(rtpStore)
    let marr = ['Enumerating Routes...', 'Calculating Cost...',
        'Loading Schedules...', 'Fetching Transport Rates...', 'Optimizing Results...',
        'Sorting Results...', 'Serializing ...']
    message = '' + message
    if (message.startsWith('Fetching')) {
        let m = marr[rtpStore.loadingCounter % 5]
        if (!m || typeof m == 'undefined') m = 'Enumerating Routes...'
        return <div className="title is-3" style={{ color: 'blueviolet', marginBottom: "100px" }}>{'' + m}</div>
    }
    return (
        <div className="title is-5">{'' + message}</div>
    )

}

function FiltersMenu({showSortBy}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const isOpen = Boolean(anchorEl);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => {
        setAnchorEl(null);
    };
    return <>
        <div onClick={handleClick} className="cursor-pointer bg-white rounded-[9px] flex flex-row gap-2 h-[46px] px-4 justify-center items-center border-1 border-solid border-[#DADADA]">
            <img style={{ height: "15px", width: "15px" }} src={filtericon} />
            <p className="text-black">Filters</p>
        </div>
        <Menu  anchorEl={anchorEl}
            open={isOpen}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
                <div className="max-h-[320px] overflow-y-auto">
                <QuickQuoteFilters showSortBy={showSortBy} />
                </div>
            </Menu>
    </>
}

export default function ViewEnquiryv3(props) {
    const [space, setSpace] = useState('')
    const [openDocModal,setOpenDocModal] = useState(false)
    const [graphList, setGraphList] = useState([])
    const [checkgraphList, setCheckGraphList] = useState(false)
    const [isButtonClicked, setButtonClicked] = useState(false);
    const [isBLReprocessing, setIsBLReprocessing] = useState(false);
    const isBLReprocessingRef = useRef(false);
    const [cost, setCost] = useState(false);
    const [costdata, setCostdata] = useState({});
    const [show, setShow] = useState(false);
    const [prList, setPrList] = useState([])
    const [bookingType, setBookingType] = useState("")
    const [erpnumber, setErpnumber] = useState("NA")
    
    const [openHoldModel, setHoldModelClose] = useState(false);
    const [openblockBookingModel, setblockBookingModelClose] = useState(false);
    const [csref, setCsref] = useState("")
    const [prevdata, setPrevdata] = useState({});
    const [routesEmptyMessage, setRoutesEmptyMessage] = useState('')
    const [routes, setRoutes] = useState([])
    const [payloaddata, setPayloaddata] = useState({})
    const [routeFilter, setRouterFilter] = useState('Cheapest')
    const [serverTime, setServerTime] = useState(0)
    const [agentEntity, setAgentEntity] = useState(undefined)
    const [creating, setCreating] = useState(false);
    useSnapshot(filtersState);
    useSnapshot(rtpStore)

    useEffect(() => {
        setIsBLReprocessing(false);
        isBLReprocessingRef.current = false;
    }, [bookingsStore.current?.blGeneration?.status, bookingsStore.current?.blGeneration?.updatedAt]);

    const handleCargoOnHold = async (key, bookingId) => {
        loader.show();
        const result = Api.cargoOnHold({key, bookingId})
        loader.hide();
    }
    const handleBookingBlock = async (key, bookingId) => {
        loader.show();
        const result = Api.blockthisBooking({key, bookingId})
        loader.hide();
    }

    const getExchangerates = async( ) =>{
        await Api.getExchangerates()
      }
      const getpr = (d)=>{
        let l = d
        for (let i = 0; i < prList.length; i++) {
            if(d==prList[i]['email']){
                l = `${prList[i]['firstName']} ${prList[i]['lastName']} (${prList[i]['email']})`
            }
        }
        return l
    }
    useLayoutEffect(() => {
        getExchangerates()
        setTimeout(() => {
            setSpace(' ')
        }, 300);
        AguserApi.getUsers4role_new("Procurement", setPrList)
    }, [])
    useSnapshot(contractsStore)
    useSnapshot(enquiryStore)
    useSnapshot(configStore)
    useSnapshot(bookingsStore)
    useSnapshot(taskStore)
    useSnapshot(myactionsstore)
    useSnapshot(EntityV2Store)
    useSnapshot(AgmodalStore)
    const [enabled, setEnabled] = useState(bookingsStore.current.cargoOnHold ? true : false);
    const [blockBooking, setBlockBooking] = useState(bookingsStore.current.blockbooking ? true : false);
    console.log("+=",enquiryStore)
    const cargoForm = useForm({
        defaultValues: {
            mode: "LCL",
            orginScope: false,
            destinationScope: false,
            originType: false,
            destinationType: false,
            showCargoDetailsOutGuage: false,
            showPalletLabel:false
        }
    })
    const getcost = async () =>{
        if(props.showbooking){
            let l = await MonApi.apost(GET_MYACTIONS_UPDATE_COST_COMPLETED_URI, {
  bookingNum: bookingsStore.current._id
})
            if(l.length>0){
                if(cost==false){
                    setCost(true)
                }
                if(JSON.stringify(l[0])!=JSON.stringify(costdata)){
                    setCostdata(l[0])
                }
            }else{
                if(cost!=false){
                    setCost(false)
                }
            }
        }
    }
    useEffect(()=>{
        loader.show()
        setBookingType(Utils.fetchBookingType(bookingsStore.current))
    },[])

   const updateAgentDetails = ()=>{
           rec['agentDetails'] = bookingsStore.current.contract.agentDetails;
           rec['agentAddress'] = bookingsStore.current.contract.agentAddress;
           rec['agentEntityId'] = bookingsStore.current.contract.agentEntityId;
           BookingsApi.setAgentDetails(bookingsStore.current._id, rec)
    }

    const buttonRef = useRef();
    useEffect(() => {
            rtpStore.records = routes;
            if (routes.length > 0) {
                setTimeout(() => {
                    if (buttonRef.current) {
                        buttonRef.current.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }, 200)
            }
            console.log(" the routes are ",routes)
        }, [routes])
    useEffect(() => {
        rtpStore.records = routes
        filtersState.setRoutes(routes,true,true);
    }, [routes])
    useEffect(()=>{
        if(props.showbooking && bookingsStore.current.contract.isCarting!=undefined && bookingsStore.current.contract.isCarting=='Yes'){
            setValue("cartingorder",true)
        }
        if(bookingsStore.current.cartingsheetId!=undefined && bookingsStore.current.cartingsheetId.length>0){
            if(csref!=bookingsStore.current.cartingsheetId){
                setCsref(bookingsStore.current.cartingsheetId)
            }
        }
        if(csref.length==0 && bookingsStore.current.linkedCarting!=undefined && bookingsStore.current.linkedCarting.length>0 && csref!=bookingsStore.current.linkedCarting){
            setCsref(bookingsStore.current.linkedCarting)
        }
    },[bookingsStore.current])
    useEffect(()=>{
        if((enquiryStore.current._id != undefined && enquiryStore.current._id.length>0) || enquiryStore.current.enqRoute!=undefined && enquiryStore.current.enqRoute.origin != undefined && enquiryStore.current.enqRoute.origin.length>0){
            if(enquiryStore.current.shipmentType.length>3 && enquiryStore.current.shipmentType.toLowerCase().indexOf('fcl')!=-1){
                enquiryStore.current.shipmentType = 'FCL'
                setValue("mode",'FCL');
            }else{
                setValue("mode",enquiryStore.current.shipmentType);
            }
            if(enquiryStore.current.multidest==undefined){
                if(enquiryStore.current.containerDetails==undefined) enquiryStore.current.containerDetails = [new Container()]
                if(enquiryStore.current.cargoDetails==undefined) enquiryStore.current.cargoDetails = [new Cargo()]
                setValue("multidest", [
                    {
                        destination:enquiryStore.current.enqRoute.destination,
                        cargoDetails:enquiryStore.current.cargoDetails,
                    }
                ]);
                enquiryStore.current.multidest = [
                    {
                        destination:enquiryStore.current.enqRoute.destination,
                        cargoDetails:enquiryStore.current.cargoDetails,
                    }
                ]
            }else{
                setValue("multidest",enquiryStore.current.multidest)
            }
            if(props.showbooking){
                setValue("fbaalways","Yes")
            }else{
                setValue("fbaalways","No")
            }
            setValue("containerDetails",enquiryStore.current.containerDetails)
            setValue("origin",enquiryStore.current.enqRoute.origin)
            setValue("cargoreadinessdate",enquiryStore.current.enqRoute.cargoReadinessDate)
            setValue("scope",enquiryStore.current.shipmentScope)
            setValue("shipmentType",enquiryStore.current.shipmentType)
            setValue("customerreference",enquiryStore.current.enqRoute.customerReferenceNum)
            setValue("hazardous",enquiryStore.current.hazardous === "No" ? false :true)
            setValue("quoteClass",enquiryStore.current.quoteClass)
            setValue("packingGroup",enquiryStore.current.packingGroup)
            setValue("temperature",enquiryStore.current.temperature)
            setValue("cargoValue",enquiryStore.current.cargoValue)
            setValue("unnumber",enquiryStore.current.unnumber)
            setValue("nonStackable", enquiryStore.current.nonStackable === "No" ? false :true)
            setValue("temperatureControlled", enquiryStore.current.temperatureControlled === "No" ? false :true)
            setValue("minTemperature",enquiryStore.current.minTemperature)
            setValue("maxTemperature",enquiryStore.current.maxTemperature)
            setValue("stuffingType",enquiryStore.current.stuffingType)
            setValue("destuffingType",enquiryStore.current.destuffingType)
            setValue("status",enquiryStore.current.status)
            setValue("cargoDimensionUnit",enquiryStore.current.cargoDimensionUnit)
            setValue("enqRoute",enquiryStore.current.enqRoute)
            setValue("vehicledetails",enquiryStore.current.vehicles)
            setValue('warehouse',enquiryStore.current.warehouse)
            setValue("isFba",enquiryStore.current.fba === "Yes" ? true :false)
            setValue("ior",enquiryStore.current.fbaIorRequired === "Yes" ? true :false)
            setValue("iorParty",enquiryStore.current.iorParty);
            setValue("occ",enquiryStore.current.fbaOCC === "Yes" ? true :false)
            setValue("dcc",enquiryStore.current.fbaDCC === "Yes" ? true :false)
            setValue("opal",enquiryStore.current.opal)
            setValue("dpal",enquiryStore.current.dpal)
            setValue("survey",enquiryStore.current.fbaSurvey === "Yes" ? true :false)
            setValue("storageAtDestination",enquiryStore.current.fbaSAD === "Yes" ? true :false)
            setValue("palletizationandlabelling",enquiryStore.current.fbaPAL === "Yes" ? true :false)
            setValue("days",enquiryStore.current.fbaDays!=undefined?enquiryStore.current.fbaDays:0)
            setValue("pick_up_by_amazon",enquiryStore.current.pick_up_by_amazon === "Yes" ? true :false)
            setValue("volumeInDimensions",enquiryStore.current.volumeInDimensions??true)
            if(AgmodalStore.modalPage=='ViewEnquiryBooking-v3'){
                setValue("overHeight",enquiryStore.current.overHeight === "Yes" ? true :false)
                setValue("overlength",enquiryStore.current.overlength === "Yes" ? true :false)
                setValue("topLoading",enquiryStore.current.topLoading === "Yes" ? true :false)
                setValue("fumigation",enquiryStore.current.fumigation === "Yes" ? true :false)
                setValue("headLoad",enquiryStore.current.headLoad === "Yes" ? true :false)
                setValue("doorLoad",enquiryStore.current.doorLoad === "Yes" ? true :false)
                setValue("reefer",enquiryStore.current.reefer === "Yes" ? true :false)
                setValue("overHeightValue",enquiryStore.current.overHeightValue)
                setValue("overlengthValue",enquiryStore.current.overlengthValue)
            }
            setShow(true)
            loader.hide()
        }
    },[enquiryStore.current])
    const { control, watch, register, setValue, handleSubmit, reset, clearErrors, formState, trigger, getFieldState } = cargoForm;
    const { changeCurrentMenu } = useGlobalState()
    const shipConsMigratDate = new Date("2024-05-28");
    const rec = contractsStore.current
    let e = enquiryStore.current
    let activeProduct = e.shipmentType.substr(0, 3).toLowerCase()
    console.log(enquiryStore.current)
    //console.log('>>>>>>>>>>>', rec, props.viewonly)
    /*if (!rec._id && props.viewonly) return <></>
    let title = `Create Booking - ${rec._id}`
    if (!props.viewonly) title = 'Enquiries'*/
    let title
    if (props.showbooking) {
        if (!bookingsStore.current.erpJobId) bookingsStore.current.erpJobId = ''
        // title = 'Booking Detail - ' + bookingsStore.current._id + '-' + bookingType
        title = 'Booking Detail - ' + bookingsStore.current._id
        configStore.homescreenCurrentShipmentScope = contractsStore.current.shipmentScope
    } else {
        title = 'Enquiry Detail - ' + enquiryStore.current._id
    }
    let displayCargo4fcl = false
    {
        let e = enquiryStore.current
        let stype = e.shipmentType.substr(0, 3).toLowerCase()
        configStore.homescreenCurrentShipmentType = stype
        if (stype === 'fcl' && e.shipmentScope === 'Port-to-Door') {
            displayCargo4fcl = Utils.outGaugeContainerCheck(enquiryStore.current.containerDetails)
            if (e.destuffingType === 'Dock')
                displayCargo4fcl = true
        }
        else if (stype === 'fcl' && e.shipmentScope === 'Door-to-Port') {
            displayCargo4fcl = Utils.outGaugeContainerCheck(enquiryStore.current.containerDetails)
            if (e.stuffingType === 'Dock')
                displayCargo4fcl = true
        }
        else if (stype === 'fcl' && e.shipmentScope === 'Door-to-Door') {
            displayCargo4fcl = true
            if (e.stuffingType === 'Factory' && e.destuffingType === 'Factory')
                displayCargo4fcl = Utils.outGaugeContainerCheck(enquiryStore?.current?.containerDetails)
        }else if(stype==='fcl'){
            displayCargo4fcl = Utils.outGaugeContainerCheck(enquiryStore.current.containerDetails)
        }

        //console.log('#########>>>', stype, displayCargo4fcl)
    }
    const updatecusref = (e) =>{
        if(props.showbooking && rec['customerReferenceNum']!=e){
            rec['customerReferenceNum'] = e
            BookingsApi.setcustrefBooking(bookingsStore.current._id, rec)
        }
    }

    useEffect(() => {
        Promise.all([
            new Promise((resolve) => EntityApi.GetErpId('booking', bookingsStore.current._id, resolve)),
            new Promise((resolve) => EntityApi.GetErpId('job', bookingsStore.current._id, resolve))
        ]).then(([bookingData, jobData]) => {
            setErpnumber(bookingData.erpId || jobData.erpId || "NA");
        }).catch(() => {
            setErpnumber("NA");
        });

    }, [erpnumber]);
    
    useEffect(() => {
        console.log('*** subscribing ***********')
        const unsubscribe = subscribe(myactionsstore, () => {
            let graphList1 = []
            for (let i = 0; i < myactionsstore.list.length; i++) {
                let rec = myactionsstore.list[i]
                if (rec['booking']['containershow'] == undefined) {
                    rec['booking']['containershow'] = -1
                }
                let oneGraph = []
                console.log("the rec is ",rec)
                oneGraph = Visibility.GraphLine(rec)
                // console.log("oneGraph",i+1,oneGraph);
            if (rec?.icegateResData && rec?.icegateResData?.oocDt) {
                oneGraph[oneGraph?.length-1].r7 = `OOC ${Utils.convertICEGATEDate(rec?.icegateResData?.oocDt,2)}`
            }
            if (rec?.icegateResData && rec?.icegateResData?.leoDt) {
                oneGraph[0].r7 =`LEO ${Utils.convertICEGATEDate(rec?.icegateResData?.leoDt,2)}`
            }
                // if (rec.shipmentType !== 'Air') oneGraph = Visibility.oceanGraphLine(rec)
                // else oneGraph = Visibility.airGraphLine(rec)
                let activeOn = false
                let lastactive = -1
                for (let i = oneGraph.length - 1; i >= 0; i--) {
                    let node = oneGraph[i]
                    if(rec.status_closed == 'Y' || rec.status_closed == 'Yes' || rec.booking.status == 'ARCHIVED'){
                        node.isActive = true
                    }
                    if (node.isActive && !activeOn) {
                        node.activelines = 1
                        lastactive = i
                    }
                    if (node.isActive) activeOn = true
                    if (activeOn && !node.isActive) node.isActive = true
                    if (node.isActive && i < lastactive) node.activelines = 2
                }
                graphList1.push(oneGraph)
                console.log("graphList1",graphList1);
            }
            setGraphList(graphList1)
        })
        return unsubscribe
    }, [myactionsstore])

    useEffect(()=>{
        if(JSON.stringify(prevdata)!=JSON.stringify(configStore.modalvisibledata) && props.showbooking){
            if(JSON.stringify(configStore.modalvisibledata)==JSON.stringify({})){
                BookingsApi.getBookingWithEntitie(bookingsStore.current._id, (data) => {bookingsStore.current = data})
            }
            setPrevdata(configStore.modalvisibledata)
        }
    },[configStore.modalvisibledata])
    if (graphList.length == 0) {

        console.log(myactionsstore)
        console.log(graphList)
        if (checkgraphList == false) {
            Newapi.getAllDsr4Displaybyid(bookingsStore.current._id)
            setCheckGraphList(true)
        }
    } else {

        console.log(myactionsstore)
        console.log(graphList)
    }

    useEffect(()=>{
        if(configStore.quotationModalVisible==false && graphList.length > 0){
            Newapi.getAllDsr4Displaybyid(bookingsStore.current._id)
        }
    },[configStore.quotationModalVisible])

    const displayVehicleTable = () => {
        return false
    }

    const getRoutes = async (data, e) => {
                let cargo = []
                let container = []
                let obj = {}
                let multidest_new = []
                for (let i = 0; i < data.multidest.length; i++) {
                    let z1 = {}
                    z1['destination'] = data.multidest[i]['destination']
                    z1['cargoDetails'] = []
                    if (i == 0) {
                        enquiryStore.current.enqRoute.destination = data.multidest[i]['destination']
                    } else {
                        let k = i + 1
                        enquiryStore.current.enqRoute['destination' + k] = data.multidest[i]['destination']
                    }
                    for (let j = 0; j < data.multidest[i]['cargoDetails'].length; j++) {
                        let k = data.multidest[i]['cargoDetails'][j]
                        k = Utils.setCargo_unit(k, data.multidest[0]['cargoDetails'][0], ['weight', 'chargeableWeight', 'volume', 'totalWeight', 'totalVolume', 'dimensions'], data.cargoDimensionUnit)
                        z1['cargoDetails'].push(k)
                        cargo.push(k)
                    }
                    multidest_new.push(z1)
                }
                for (let j = 0; j < data.containerDetails.length; j++) {
                    let z = data.containerDetails[j]['containerType']
                    if (obj[z] == undefined) {
                        obj[z] = {
                            containerType: "",
                            numContainers: 0,
                            unit: "",
                            wtPerContainer: 0
                        }
                    }
                    obj[z]['containerType'] = z
                    obj[z]['unit'] = data.containerDetails[0]['unit']
                    obj[z]['numContainers'] = obj[z]['numContainers'] + Number(data.containerDetails[j]['numContainers'])
                    obj[z]['wtPerContainer'] = Number(data.containerDetails[j]['wtPerContainer'])
                }
                let o = Object.keys(obj)
                for (let i = 0; i < o.length; i++) {
                    obj[o[i]]['wtPerContainer'] = obj[o[i]]['wtPerContainer']
                    container.push(obj[o[i]])
                }
                enquiryStore.current.enqRoute.origin = data.origin
                enquiryStore.current.multidest = JSON.parse(JSON.stringify(multidest_new));
                console.log('\n\n\n\n\n==============================')
                console.log('/', enquiryStore.current.enqRoute.origin, '/', enquiryStore.current.enqRoute.destination, rtpStore, '/\n===============\n\n\n')
                setRoutes([])
                setRoutesEmptyMessage('Fetching Routes ...')
                rtpStore.loadingMessage = 'Fetching Routes '
                rtpStore.loadingTimer = setInterval(() => {
                    rtpStore.loadingCounter++
                }, 10000);
                setRouterFilter('Cheapest')
                let curDate = enquiryStore.current.enqRoute.cargoReadinessDate
                let url = `${process.env.REACT_APP_PRICINGAPI_SERVER}/api/v1/pricing/getroutes`
                if (activeProduct.toLowerCase().indexOf('fcl') != -1) url = `${process.env.REACT_APP_PRICINGAPI_SERVER}/api/v1/fclpricing/getroutesv2`
                else if (activeProduct.toLowerCase().indexOf('air') != -1) url = `${process.env.REACT_APP_PRICINGAPI_SERVER}/api/v1/airpricing/getroutes`
                let start = Date.now()
                enquiryStore.current.createdBy = loginStore.email
                let otype = enquiryStore.current.shipmentScope.split("-")[0];
                let dtype = enquiryStore.current.shipmentScope.split("-")[2];
                let crd = '' + enquiryStore.current.enqRoute.cargoReadinessDate
                crd = crd.trim()
                let dimunit = enquiryStore.current.cargoDimensionUnit
                for (let e of enquiryStore.current.cargoDetails) {
                    e.dimensions.unit = dimunit
                }
                let displayCargo4fcl = false
                let stype = enquiryStore.current.shipmentType.substr(0, 3).toLowerCase()
                displayCargo4fcl = false
                if (stype === 'fcl') {
                    displayCargo4fcl = Utils.outGaugeContainerCheck(enquiryStore.current.containerDetails)
                    if (enquiryStore.current.originType != 'Port' && enquiryStore.current.stuffingType != 'Factory') displayCargo4fcl = true
                    if (enquiryStore.current.destinationType != 'Port' && enquiryStore.current.destuffingType != 'Factory') displayCargo4fcl = true
                }
                let payload = {
                    entity: enquiryStore.current.entityId,
                    // entity: "CEN0665",
                    origin: enquiryStore.current.enqRoute.origin,
                    destination: enquiryStore.current.enqRoute.destination,
                    sscope: `${otype}-to-${dtype}`,
                    crd: enquiryStore.current.enqRoute.cargoReadinessDate,
                    curDate,
                    cargoDetails: enquiryStore.current.cargoDetails,
                    vehicleDetails: enquiryStore.current.vehicleDetails,
                    fclCargoApplicable: displayCargo4fcl,
                    enquiry: enquiryStore.current
                }
                for (let i = 1; i < enquiryStore.current.multidest.length; i++) {
                    if (i != 0) {
                        let k = i + 1
                        payload['destination' + k] = enquiryStore.current.multidest[i]['destination']
                    }
                }
                if (rtpStore.customerTBA == 'TBA') {
                    payload.entity = 'COUNTRY:' + rtpStore.countryName
                }
                if (!PricingUtils.getTotalVehicleCount(payload.vehicleDetails) && displayVehicleTable()) {
                    configStore.setModalMessage('At least one vehicle needs to be selected for India transport=')
                    return
                }
                let ocountry = 'origin'
                let portre = /.*\((.....)\)$/
                let doorre = /.*\[(..,.*)\]$/
                let origin1 = payload.origin
                let destination1 = payload.destination
                if (origin1.includes('(') || origin1.includes('[')) {
                    if (otype == 'Port') ocountry = origin1.match(portre)[1].slice(0, 2)
                    else ocountry = origin1.match(doorre)[1].slice(0, 2)
                }
                let dcountry = 'destination'
                if (destination1.includes('(') || destination1.includes('[')) {
                    if (dtype == 'Port') dcountry = destination1.match(portre)[1].slice(0, 2)
                    else dcountry = destination1.match(doorre)[1].slice(0, 2)
                }
                if (ocountry == dcountry) {
                    configStore.setModalMessage('We do not have Domestic Transport Capabilities at present' + ocountry + '/' + dcountry)
                    return
                }
                setPayloaddata(payload)
                let ret = []
                if (ocountry != 'IN' && ocountry != 'origin' && dcountry != 'IN' && dcountry != 'destination') {
                    /*configStore.setModalMessage('We do not serve these routes at present and will keep you posted when we launch in these markets')
                    enquiryStore.current.enqRoute.origin = ''
                    enquiryStore.current.enqRoute.destination = ''
                    return*/
                } else if(enquiryStore.current.shipmentType != "Air") ret = await MonApi.apost(url, payload)
                if (ret.additionalsets) rtpStore.additionalsets = ret.additionalsets
                if (ret.finalset) ret = ret.finalset
                rtpStore.dpd = 'Direct Port Delivery'
                // ##################################################################
                console.log('payload==', JSON.stringify(payload))
                //console.log('new data=', enquiryStore.current.originType, enquiryStore.current.destinationType)
                setServerTime(Date.now() - start)
                clearInterval(rtpStore.loadingTimer)
                rtpStore.loadingCounter = 0
                console.log("The ret is ", ret);
                if (ret.error) {
                    setRoutesEmptyMessage('')
                    configStore.setModalMessage('' + ret.error, [], true, [], '', 5000)
                } else {
                    for (let i = 0; i < ret.length; i++) {
                        ret[i].dummyContract['entityId'] = enquiryStore.current.entityId
                        ret[i].dummyContract['nomination'] = enquiryStore.current.nomination
                        ret[i].dummyContract['salesperson'] = enquiryStore.current.salesperson
                        ret[i].dummyContract['customerService'] = enquiryStore.current.customerService
                        ret[i].dummyContract['entityName'] = enquiryStore.current.entityName
                        ret[i].quote['entityId'] = enquiryStore.current.entityId
                        ret[i].quote['nomination'] = enquiryStore.current.nomination
                        ret[i].quote['salesperson'] = enquiryStore.current.salesperson
                        ret[i].quote['customerService'] = enquiryStore.current.customerService
                        ret[i].quote['entityName'] = enquiryStore.current.entityName
                        ret[i].quote.quoteSummary['entityId'] = enquiryStore.current.entityId
                        ret[i].quote.quoteData['entityId'] = enquiryStore.current.entityId
                        ret[i].quote.quoteData['nomination'] = enquiryStore.current.nomination
                        ret[i].quote.quoteData['salesperson'] = enquiryStore.current.salesperson
                        ret[i].quote.quoteData['customerService'] = enquiryStore.current.customerService
                        ret[i].quote.quoteData['entityName'] = enquiryStore.current.entityName
                        if (i == ret.length - 1) {
                            setRoutes(ret)
                        }
                    }
                    if (!ret || !ret.length) {
                        setRoutesEmptyMessage('No Routes')
                    }
                }
        }

    const handleCreateJob = async () => {
        const current = bookingsStore.current;
        if (!current?._id || creating) return;

        setCreating(true);
        try {
            const [dsrList, bookingList] = await Promise.all([
                MonApi.apost(GET_BOOKINGDSR_BY_FILTER_URI, { _id: current._id }),
                MonApi.apost(GET_BOOKINGS_IDS_URI, { _id: current._id }),
            ]);

            const dsr = dsrList?.[0];
            const booking = bookingList?.[0];
            console.log(booking, "checking for bookisdnhdsbfjsdh");

            const existingJobId = booking?.jobId?.trim();
            if (existingJobId) {
                configStore.setModalMessage(`Job already exists! Reference ID: ${existingJobId}`);
                return;
            }

            const contract = current.contract || {};

            const containerDetails = Utils.createContainerDetails(dsr, booking);

            // if (!containerDetails.length) {
            //     configStore.setModalMessage("No container details found in DSR or booking.");
            //     return;
            // }

            const requestPayload = {
                generalDetails: {
                    origin: contract.portOfReceipt,
                    destination: contract.finalPlaceOfDelivery,
                    por: contract.portOfReceipt,
                    pol: contract.portOfLoading,
                    pod: contract.portOfDischarge,
                    fpod: contract.finalPlaceOfDelivery,
                    etd: Utils.formatToSave(dsr?.etd_at_pol || ""),
                    eta: Utils.formatToSave(dsr?.eta_at_pod || dsr?.eta_fpod),
                },
                "carrierDetails": {
                    carrier: contract?.carrier,
                },
                containerDetails,
                linkedBookings: [current._id],
                linkedERPBookingDetails: [{
                    bookingId: current?._id,
                    hblNumber: current?.erpBookingId || "",
                    erpMasterLinked: false,
                }],
                tradeType: "Export",
                service: "FCL",
                freight: current.paymentType || "Prepaid",
                shipmentScope: "Port-to-Port",
                type: "BOOKINGS"
            };

            Api.addMasterJob(requestPayload, (data) => {
                setCreating(false);
                if (!data?.jobId) {
                    configStore.setModalMessage(data?.msg || "Unable to create job");
                    return;
                }
                loader.show()
                Api.getmasterjobbyid(data.jobId, (d) => {
                    try {
                        const result = d?.results?.result;
                        if (!result) throw new Error("Job details not found");

                        resetMasterJobStore();

                        masterjobStore.disable = false;
                        masterjobStore.edit = true;
                        masterjobStore.current = JSON.parse(JSON.stringify(result));
                        masterjobStore.bookingData = JSON.parse(JSON.stringify(d.results.bookingData ?? []));
                        masterjobStore.linkedBookingData = JSON.parse(
                            JSON.stringify(d.results.linkedBookingList ?? [])
                        );
                        AgmodalStore.modalPage = "masterjob";
                        AgmodalStore.apiCall = false;
                        configStore.modalVisible = false;
                        AgmodalStore.pageVisible = true;

                    } catch (err) {
                        console.error("Failed to open job:", err);
                        configStore.setModalMessage(`${data.msg}. But the job could not be opened.`);
                    } finally {
                        loader.hide();
                    }
                });
            });
        } catch (err) {
            console.error("Create job failed:", err);
            configStore.setModalMessage("Failed to create job. Please try again.");
        } finally {
            setCreating(false);
        }
    };
    if (taskStore.triggerActionVisible) return <TaskTrigger />
    if (taskStore.vendorAssignment) return <VendorAssignment />
    if (taskStore.loadERP) return <LoadERP type={taskStore.loadERP}/>
    const finalDelivery = props.showbooking?bookingsStore.current.contract.finalPlaceOfDelivery?.toLowerCase():""
    const portOfReceipt = props.showbooking?bookingsStore.current.contract.portOfReceipt?.toLowerCase():""
    const exportCondition = !finalDelivery.includes('india');
    const importCondition = finalDelivery.includes('india') && !portOfReceipt.includes("india");
    return (
        <>
        {
            taskStore.costmodal?<Costmodal rec={costdata} />:""
        }
        {
            configStore.cartingmodal?<Cartingmodal />:""
        }
        {
            configStore.shippingbillmodal?<ShippingBillmodal />:""
        }
        {
            show && <>
            <ActrejectModal6 type={"cancel"} id={e._id} />
            {space}
            <div className="columns ">
                <div className="column"  style={{display:"flex",justifyContent:"start",alignItems:"center"}}>
                { loginStore.isClient() &&  <IconButton disableRipple onClick={()=>{
                 bookingsStore.currentBookingsListComponent = "list"
            }}>
                <img src={backarrow}/>
            </IconButton> }
                    <h5 className="title is-4" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR, fontFamily: 'product_sans_bold' }}>
                        {title}
                    </h5>
                    <></>
                </div>
                <div className="column is-1">
                    {
                        // (props.showbooking && !loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS.EDIT.BOOKING_VENDOR)) ?
                        (props.showbooking && !loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.ASSIGN_VENDOR)) ?
                            <button disabled={!bookingsStore.current.contract} style={{ marginTop: '10px' }} className="button islink"
                                onClick={async(e) => {
                                    // EntityV2Api.checkMyactionEnt(bookingsStore.current.entityId ,bookingsStore.current.branchId , (data) => {
                                    //     if(data.status === 200) {
                                    //         taskStore.current = new Task('')
                                    //     taskStore.current.initialize(bookingsStore.current, entityStore.entityRec)
                                    //     taskStore.vendorAssignment = true
                                    //     }
                                    //   } )
                                    taskStore.vendorAssignment = true
                                }}>Vendor</button>
                            : <></>
                    }
                </div>
                {/* {
                        (props.showbooking && !loginStore.isClient() && cost) ?
                <div className="column is-1">
                    
                            <button disabled={!bookingsStore.current.contract} style={{ marginTop: '10px' }} className="button islink"
                                onClick={async(e) => {
                                    taskStore.costmodal=true
                                }}>Cost</button>
                            
                </div>: <></>
                    } */}
               {/* <div className="column is-2">
     {
        props.showbooking && !loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.TRIGGER_ACTION) ? (
            <>
                <button
                    disabled={!bookingsStore.current.contract}
                    className="button is-link is-fullwidth"
                    style={{ marginBottom: '10px' }}
                    onClick={async (e) => {
                        taskStore.loadERP = 'job';
                    }}
                >
                    Job to ERP
                </button>
                { 'EXPORT' === Utils.fetchBookingType(bookingsStore.current).toUpperCase() &&
                <button
                    disabled={!bookingsStore.current.contract}
                    className="button is-link is-fullwidth"
                    onClick={async (e) => {
                        taskStore.loadERP = 'booking';
                    }}
                >
                    Booking to ERP
                </button>}
            </>
        ) : null
    } 
</div> */}

                <div className="column is-1">
                    {
                        (props.showbooking && !loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.TRIGGER_ACTION)) ?
                            <button disabled={!bookingsStore.current.contract} style={{ marginTop: '10px' }} className="button islink"
                                onClick={async(e) => {
                                    if(bookingsStore.listActiveTab === 'Shipments On Hold' || enabled){
                                        return configStore.setModalMessage('Cargo is on Hold')
                                    }
                                    if(EntityV2Store.EntityRec.customer.crossBorder.salesVertical !== 'MSME'){
                                        setOpenDocModal(true)
                                    }
                                    else{
                                        EntityV2Api.checkMyactionEnt(bookingsStore.current.entityId ,bookingsStore.current.branchId , (data) => {
                                        if(data.status === 200) {
                                            taskStore.current = new Task('')
                                            taskStore.currencyData = {label: "", currencyType: "", emarks: "", netAmount: 0, gstAmount: 0, totalAmount: 0,}
                                            taskStore.current.initialize(bookingsStore.current, entityStore.entityRec)
                                            taskStore.triggerActionVisible = true
                                          }
                                        })
                                    }
                                   
                                }}>Action</button>
                            : <></>
                    }
                </div>
                <div className="column is-2">
                    {
                        (!loginStore.isClient() && props.showbooking) ?
                            <div style={!RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.UPDATE_JOB_NUMBER) ? { display: 'flex', justifyContent: 'center', pointerEvents: 'none', opacity: 0.6 } : { display: 'flex', justifyContent: 'center' }}>
                                <span>
                                    <AgInput placeholder={"FE-12350880-01"} label='Sub-job Number' value={erpnumber} record={bookingsStore.current}
                                        name='erpJobId'/>
                                </span>
                                <span>
                                    <button className="button is-small islink"
                                        style={{ marginTop: '1rem' }}
                                        onClick={async () => {
                                            try {
                                                // if (!(/^([A-Z]){3}([/])([A-Z]){2}([/])\d{2}([/])\d{2}([/])([A-Z]){1}([/])\d{4}/.test(bookingsStore.current.erpJobId))) {
                                                //     configStore.setModalMessage('ERP Job ID is not valid.')
                                                //     return;
                                                // }
                                                if(bookingsStore.current.erpJobId!=undefined && bookingsStore.current.erpJobId.trim().length==0){
                                                    configStore.setModalMessage('ERP Job ID should not save as empty')
                                                    return;
                                                }
                                                let isBookingExistsWithSame = await MonApi.apost(GET_BOOKINGS_IDS_URI, {
  erpJobId: bookingsStore.current.erpJobId
})
                                                    .then(res => Array.isArray(res) && res?.length > 0);
                                                if (isBookingExistsWithSame) {
                                                    configStore.setModalMessage('ERP Job ID with booking is already exists.')
                                                    return;
                                                }
                                                let ret = await MonApi.apost(UPDATE_BOOKING_FIELDS_URI, {
  _id: bookingsStore.current._id,
  erpJobId: bookingsStore.current.erpJobId
})
                                                if (ret.error) configStore.setModalMessage('' + ret.error)
                                                else configStore.setModalMessage('ERP Job ID updated successfully.')
                                            } catch (e) {
                                                configStore.setModalMessage('Error trying to save ERP ID')
                                            }
                                        }}>
                                        Save
                                    </button>
                                </span>
                            </div>
                            : <></>
                    }
                </div>
                <div className="column is-2">
                    {
                        (!loginStore.isClient() && props.showbooking) ?
                            <div style={!RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.UPDATE_BOOKING_NUMBER) ? { display: 'flex', justifyContent: 'center', pointerEvents: 'none', opacity: 0.6 } : { display: 'flex', justifyContent: 'center' }}>
                                <span>
                                    <AgInput label={enquiryStore.current.shipmentType.indexOf('Air')!=-1?"ERP Booking #":"HBL Number"} record={bookingsStore.current}
                                        name='erpBookingId'  isDisabled={{disabled:enquiryStore.current.shipmentType.indexOf('Air') == -1 && !!bookingsStore.current.erpBookingId && !!bookingsStore.current.erpShipmentId && !RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.EDIT_FROZEN_HBL_NUMBER)}}/>
                                </span>
                                <span>
                                    <button className="button is-small islink"
                                        disabled={enquiryStore.current.shipmentType.indexOf('Air') == -1  && !!bookingsStore.current.erpBookingId && !!bookingsStore.current.erpShipmentId && !RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.EDIT_FROZEN_HBL_NUMBER)}
                                        style={{ marginTop: '1rem' }}
                                        onClick={async () => {
                                            try {
                                                // if (!(/^([A-Z]){3}([/])([A-Z]){2}([/])\d{2}([/])\d{2}([/])([A-Z]){1}([/])\d{4}/.test(bookingsStore.current.erpJobId))) {
                                                //     configStore.setModalMessage('ERP Job ID is not valid.')
                                                //     return;
                                                // }
                                                if(bookingsStore.current.erpBookingId!=undefined && bookingsStore.current.erpBookingId.trim().length==0){
                                                    configStore.setModalMessage(`${enquiryStore.current.shipmentType.indexOf('Air')==-1?"HBL Number":"ERP Booking ID"} should not save as empty`)
                                                    return;
                                                }
                                                let isBookingExistsWithSame = await MonApi.apost(GET_BOOKINGS_IDS_URI, {
  erpBookingId: bookingsStore.current.erpBookingId
})
                                                    .then(res => Array.isArray(res) && res?.length > 0);
                                                if (isBookingExistsWithSame) {
                                                    configStore.setModalMessage(`${enquiryStore.current.shipmentType.indexOf('Air')==-1?"HBL Number":"ERP Booking ID"} with booking is already exists.`)
                                                    return;
                                                }
                                                let ret = await MonApi.apost(UPDATE_BOOKING_FIELDS_URI, {
  _id: bookingsStore.current._id,
  erpBookingId: bookingsStore.current.erpBookingId
})
                                                    if(enquiryStore.current.shipmentType.indexOf('Air')==-1){
                                                        await MonApi.apost(UPDATE_BOOKINGDSR_BY_ID_URI, {
  _id: bookingsStore.current._id,
  hbl_number: bookingsStore.current.erpBookingId
})  
                                                         Newapi.getAllDsr4Displaybyid(bookingsStore.current._id)
                                                    }
                                                if (bookingsStore.current?.shippingDetails && bookingsStore.current?.shippingDetails?.manifestHblNo) {
                                                    await MonApi.apost(UPDATE_BOOKING_FIELDS_URI, {
                                                        _id: bookingsStore.current._id,
                                                        "shippingDetails.manifestHblNo": bookingsStore.current.erpBookingId
                                                    })
                                                }
                                                if (ret.error) configStore.setModalMessage('' + ret.error)
                                                else configStore.setModalMessage(`${enquiryStore.current.shipmentType.indexOf('Air')==-1?"HBL Number":"ERP Booking ID"} updated successfully.`)
                                            } catch (e) {
                                                configStore.setModalMessage('Error trying to save ERP ID')
                                            }
                                        }}>
                                        Save
                                    </button>
                                </span>
                            </div>
                            : <></>
                    }
                </div>
                      <div className="column is-1">{
                         (
                    RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.SYNC_WITH_ERP) &&
                    bookingsStore.current?.status !== "CANCELLED" &&
                    bookingsStore.current.contract?.shipmentType != SHIPMENT_TYPE.air &&
                    (exportCondition || importCondition)
                ) &&
                <div style={{marginTop: '1rem', position: "relative"}}><button className="button is-small islink"  disabled={bookingsStore?.current?.erpSyncStatus === "PROCESSING"}
                                    onClick={(e) => {
                                        if (!bookingsStore.current.erpSync) {
                                            bookingsStore.current.erpSync = {};
                                        }

                                        const oldErpSyncStatus = bookingsStore.current.erpSyncStatus;
                                        const oldErpSyncAt = bookingsStore.current.erpSyncAt;

                                        bookingsStore.current.erpSyncStatus = "PROCESSING";
                                        bookingsStore.current.erpSyncAt = new Date().toISOString();
                                        Api.bookingErpSync(bookingsStore.current._id, (data) => {
                                        if (data.msg === "Request intitated") {
                                            bookingsStore.current.erpSyncStatus = data.data.erpSyncStatus;
                                            bookingsStore.current.erpModifiedBy = data.data.erpModifiedBy;
                                            bookingsStore.current.erpSyncAt = data.data.erpSyncAt;
                                        }else if(data.msg === "No changes to sync"){
                                            bookingsStore.current.erpSyncStatus = oldErpSyncStatus;
                                            bookingsStore.current.erpSyncAt = oldErpSyncAt;
                                        }
                                        configStore.setModalMessage(data.msg);
                                        });
                                    }}
                                    >
                                    Sync with ERP
                                    </button> 
                                {
                                    bookingsStore.current?.erpModifiedBy &&
                                    bookingsStore.current?.erpSyncAt && (
                                        <div
                                            style={{
                                                marginTop: "6px",
                                                fontSize: "12px",
                                                color: "#666",
                                                lineHeight: "18px",
                                                width: "max-content",
                                                 zIndex: 1,
                                                 position: "absolute"
                                            }}
                                        >
                                            <div>
                                                Synced At: {new Date(bookingsStore.current.erpSyncAt).toLocaleString()}
                                            </div>

                                            <div>
                                                Synced By: {bookingsStore.current.erpModifiedBy}
                                            </div>
                                            {bookingsStore.current?.erpShipmentId && (<div>
 
                                            ERP ShipmentId: {bookingsStore.current.erpShipmentId}
                                            
                                            </div>)}
                                        </div>
                                    )
                                }</div>
                                    }</div>                
            
               <div className="column is-2">
                    {
                        (!loginStore.isClient() && props.showbooking) ?
                            <div style={{ display: 'flex', justifyContent: 'center'}} >
                    
                            <button disabled={!bookingsStore.current.contract} style={{ marginTop: '10px' }} className="button islink"
                                onClick={async(e) => {
                                    configStore.cartingmodal=true
                                }}>Carting Sheet</button>
                            </div>
                            : <></>
                    }
                </div>
 
                
                
            </div>
            {(props.showbooking && 
            (bookingsStore.listActiveTab === "Submitted Bookings" || bookingsStore.listActiveTab === "Shipments In-Progress"  || bookingsStore.listActiveTab === 'Shipments On Hold')) && 
               <div
                    className="p-4"
                    style={{
                        display: "flex",
                        gap: "16px",
                        flexWrap: "wrap",
                        alignItems: "center"
                    }}
                >
                    <span className="title is-5 mr-2" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR_TERTIARY, fontFamily: 'product_sans_bold' }}>Make Cargo on {!enabled ? 'Hold?' : 'Release?'}</span>
                    <button
                        disabled={blockBooking}
                        type="button"
                        onClick={() => {
                            delete taskStore.booking.invoiceDetails
                            setEnabled(!enabled)
                            setHoldModelClose(true)
                        }}
                        className={`border-none relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
                        enabled ? 'bg-blue-500' : 'bg-gray-300'
                        }`}
                        style={{ backgroundColor: enabled ? '#1976D2' : '#D4D4D4' }}
                    >
                        <span
                        className={`border-none inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
                            enabled ? 'translate-x-6' : 'translate-x-1'
                        }`}
                        />
                    </button>
                    {
                        process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE === 'Navexel' ? 
                        <div className='ml-5'>
                            <span className="title is-5 mr-2" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR_TERTIARY, fontFamily: 'product_sans_bold' }}>Suppress Booking?</span>
                            <button
                                disabled={enabled}
                                type="button"
                                onClick={() => {
                                    setBlockBooking(!blockBooking)
                                    setblockBookingModelClose(true)
                                }}
                                className={`border-none relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 ${
                                blockBooking ? 'bg-blue-500' : 'bg-gray-300'
                                }`}
                                style={{ backgroundColor: blockBooking ? '#1976D2' : '#D4D4D4' }}
                            >
                                <span
                                className={`border-none inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-300 ${
                                    blockBooking ? 'translate-x-6' : 'translate-x-1'
                                }`}
                                />
                            </button>
                            { blockBooking ?
                                <div className="mt-2">
                                    <p className="text-sm">Suppressed By: {bookingsStore.current?.blockbooking_updatedBy}</p>
                                    <p className="text-sm">Suppressed On: {Utils.DDMMYYYHHAMPM(bookingsStore.current?.blockbooking_createdTime)}</p>
                                </div> : 
                                bookingsStore.current?.blockbooking_UpdatedTime ? 
                                    <div className="mt-2">
                                        <p className="text-sm">Suppressed By: {bookingsStore.current?.blockbooking_updatedBy}</p> 
                                        <p className="text-sm">Suppressed Off: {Utils.DDMMYYYHHAMPM(bookingsStore.current?.blockbooking_UpdatedTime)}</p>
                                    </div> : 
                                <></>
                            }
                        </div> : <></>
                    }
                        {(bookingsStore?.current?.contract?.shipmentType?.includes('FCL') && bookingsStore?.current?.containerDetails?.length > 0) && <div>
                            <button
                                className="button islink"
                                onClick={handleCreateJob}
                                disabled={creating}
                            >
                                {creating ? "Creating..." : "Create Job"}
                            </button>
                        </div>}
                    <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "8px" }}>
                         {bookingsStore.current?.blGeneration && (
                             <>
                                 <span className="title is-5 mr-2" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR_TERTIARY, fontFamily: 'product_sans_bold', margin: 0 }}>BL Generation:</span>
                                 <span
                                     style={{
                                         display: "inline-flex",
                                         alignItems: "center",
                                         fontSize: "11px",
                                         fontWeight: "800",
                                         color:
                                             ["success", "approved"].includes(bookingsStore.current.blGeneration.status)
                                                 ? "#2ecc71"
                                                 : bookingsStore.current.blGeneration.status === "processing"
                                                 ? "#f39c12"
                                                 : "#e74c3c",
                                         background:
                                             ["success", "approved"].includes(bookingsStore.current.blGeneration.status)
                                                 ? "#e8f8f0"
                                                 : bookingsStore.current.blGeneration.status === "processing"
                                                 ? "#fef5e7"
                                                 : "#fdedec",
                                         padding: "2px 8px",
                                         borderRadius: "12px",
                                         textTransform: "uppercase"
                                     }}
                                     title={bookingsStore.current.blGeneration.remarks}
                                 >
                                     <span
                                         style={{
                                             height: "6px",
                                             width: "6px",
                                             borderRadius: "50%",
                                             backgroundColor: "currentColor",
                                             display: "inline-block",
                                             marginRight: "4px"
                                         }}
                                     />
                                     {bookingsStore.current.blGeneration.status}
                                     {bookingsStore.current.blGeneration.status === "approved" && (
                                         <span style={{ marginLeft: "4px", fontSize: "12px", fontWeight: "bold" }}>✓</span>
                                     )}
                                 </span>
                                 {bookingsStore.current.blGeneration.remarks && (
                                     <span style={{ fontSize: "11px", color: "#7f8c8d" }} title={bookingsStore.current.blGeneration.remarks}>
                                         ({bookingsStore.current.blGeneration.remarks.length > 40 
                                           ? bookingsStore.current.blGeneration.remarks.substring(0, 40) + "..." 
                                           : bookingsStore.current.blGeneration.remarks})
                                     </span>
                                 )}
                                 {bookingsStore.current.blGeneration.updatedAt && (
                                     <span style={{ fontSize: "11px", color: "#95a5a6" }}>
                                         {Utils.DDMMYYYHHAMPM(new Date(bookingsStore.current.blGeneration.updatedAt).getTime())}
                                     </span>
                                 )}
                             </>
                         )}
                         {process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE === 'navexel' && !isBLReprocessing && (bookingsStore.current?.blGeneration?.status === "error"  || bookingsStore.current?.blGeneration?.status === "failed") && (
                              <>
                                  <button
                                      className="button is-small is-info ml-2"
                                      disabled={isBLReprocessing}
                                      onClick={async () => {
                                          if (isBLReprocessingRef.current) return;
                                          isBLReprocessingRef.current = true;
                                          try {
                                              setIsBLReprocessing(true);
                                              configStore.setModalMessage("Reprocessing BL...");
                                              await BookingsApi.reprocessBL(bookingsStore.current._id, {}, (data) => {
                                                  configStore.setModalMessage(data.msg || "BL Reprocessing request sent");
                                              });
                                          } catch (err) {
                                              console.error(err);
                                              configStore.setModalMessage("Failed to reprocess BL");
                                              setIsBLReprocessing(false);
                                              isBLReprocessingRef.current = false;
                                          }
                                      }}
                                      style={{
                                          height: "26px",
                                          fontSize: "11px",
                                          fontWeight: "600",
                                          borderRadius: "4px",
                                          cursor: isBLReprocessing ? "not-allowed" : "pointer"
                                      }}
                                  >
                                      Reprocess BL
                                  </button>
                                  {bookingsStore.current?.blGeneration?.isPortMismatch && (
                                      <button
                                          className="button is-small is-warning ml-2"
                                          disabled={isBLReprocessing}
                                          onClick={async () => {
                                              if (isBLReprocessingRef.current) return;
                                              isBLReprocessingRef.current = true;
                                              try {
                                                  setIsBLReprocessing(true);
                                                  configStore.setModalMessage("Reprocessing BL holding existing ports...");
                                                  await BookingsApi.reprocessBL(bookingsStore.current._id, { action: "hold-existing-ports" }, (data) => {
                                                      configStore.setModalMessage(data.msg || "BL Reprocessing request sent");
                                                  });
                                              } catch (err) {
                                                  console.error(err);
                                                  configStore.setModalMessage("Failed to reprocess BL");
                                                  setIsBLReprocessing(false);
                                                  isBLReprocessingRef.current = false;
                                              }
                                          }}
                                          style={{
                                              height: "26px",
                                              fontSize: "11px",
                                              fontWeight: "600",
                                              borderRadius: "4px",
                                              cursor: isBLReprocessing ? "not-allowed" : "pointer"
                                          }}
                                      >
                                          Use Booking Ports
                                      </button>
                                  )}
                              </>
                          )}
                     </div>
                    {/* {     
                <div >{
                (
                    RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.SYNC_WITH_ERP) &&
                    bookingsStore.current?.status !== "CANCELLED" &&
                    bookingsStore.current.contract?.shipmentType != SHIPMENT_TYPE.air &&
                    (exportCondition || importCondition)
                ) &&
               <div><button className="button is-small islink" 
                 disabled={bookingsStore?.current?.erpSyncStatus === "PROCESSING"}
                                    onClick={(e) => {
                                        Api.bookingErpSync(bookingsStore.current._id, (data) => {
                                        if (data.msg === "Request intitated") {
                                            bookingsStore.current.erpSyncStatus = data.data.erpSyncStatus;
                                            bookingsStore.current.erpModifiedBy = data.data.erpModifiedBy;
                                            bookingsStore.current.erpSyncAt = data.data.erpSyncAt;
                                        }
                                        configStore.setModalMessage(data.msg);
                                        });
                                    }}
                                    >
                                    ⟳ booking - ERP
                                    </button> 
                                {
                                    bookingsStore.current?.erpModifiedBy &&
                                    bookingsStore.current?.erpSyncAt && (
                                        <div
                                            style={{
                                                marginTop: "6px",
                                                fontSize: "12px",
                                                color: "#666",
                                                lineHeight: "18px",
                                                width: "max-content",
                                                 zIndex: 1,
                                                 position: "absolute"
                                            }}
                                        >
                                            <div>
                                                Synced At: {new Date(bookingsStore.current.erpSyncAt).toLocaleString()}
                                            </div>

                                            <div>
                                                Synced By: {bookingsStore.current.erpModifiedBy}
                                            </div>

                                            {bookingsStore.current?.erpShipmentId && (<div>
                                                ERP ShipmentId: {bookingsStore.current.erpShipmentId}
                                            </div>)}
                                        </div>
                                    )
                                }
                                  { <button className="button is-small islink is-5 ml-5 mr-2" 
                 disabled={bookingsStore?.current?.erpSyncStatus === "PROCESSING"}
                                    onClick={(e) => {
                                        Api.chargesErpSync(bookingsStore.current._id, (data) => {
                                        if (data.msg === "Request intitated") {
                                            bookingsStore.current.erpSyncStatus = data.data.erpSyncStatus;
                                            bookingsStore.current.erpModifiedBy = data.data.erpModifiedBy;
                                            bookingsStore.current.erpSyncAt = data.data.erpSyncAt;
                                        }
                                        
                                        configStore.setModalMessage(data.msg);
                                        });
                                    }}
                                    >
                                    ⟳ Charges - ERP
                                    </button> }
                                {
                                    bookingsStore.current?.erpModifiedBy &&
                                    bookingsStore.current?.erpSyncAt && (
                                        <div
                                            style={{
                                                marginTop: "6px",
                                                fontSize: "12px",
                                                color: "#666",
                                                lineHeight: "18px",
                                                width: "max-content",
                                                 zIndex: 1,
                                                 position: "absolute"
                                            }}
                                        >
                                            <div>
                                                Synced At: {new Date(bookingsStore.current.erpSyncAt).toLocaleString()}
                                            </div>

                                            <div>
                                                Synced By: {bookingsStore.current.erpModifiedBy}
                                            </div>
                                        </div>
                                    )
                                }</div>
                                    }</div>} */}
                    { openHoldModel &&
                        <div className='modal is-active' >
                            <div className="modal-background" ></div>
                                <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{ borderRadius: '10px' }} >
                                <section className="modal-card-body">
                                <h2 style={{ color: "red" }}>Are you sure you want to keep cargo {enabled ? 'on hold?' : 'release?'}</h2>
                                    <br></br>
                                    <button type="submit" class="button is-danger" style={{ float: "right" }}
                                        onClick={async (e)=>{
                                            e.preventDefault();
                                            handleCargoOnHold(enabled, bookingsStore.current._id)
                                            setHoldModelClose(false)
                                            AgmodalStore.pageVisible = false;
                                            AgmodalStore.apiCall = true;
                                        }}
                                    >Yes</button>
                                    <button class="button is-warning" onClick={() => {
                                        setEnabled(!enabled)
                                        setHoldModelClose(false)
                                    }} >No</button>
                                </section>
                            </div>
                        </div>
                    }
                    { openblockBookingModel &&
                        <div className='modal is-active' >
                            <div className="modal-background" ></div>
                                <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{ borderRadius: '10px' }} >
                                <section className="modal-card-body">
                                <h2 style={{ color: "red" }}>Are you sure you want to {blockBooking ? 'block' : 'unblock'} this Booking on Customer side?</h2>
                                    <br></br>
                                    <button type="submit" class="button is-danger" style={{ float: "right" }}
                                        onClick={async (e)=>{
                                            e.preventDefault();
                                            handleBookingBlock(blockBooking, bookingsStore.current._id)
                                            setblockBookingModelClose(false)
                                            AgmodalStore.pageVisible = false;
                                            AgmodalStore.apiCall = true;
                                        }}
                                    >Yes</button>
                                    <button class="button is-warning" onClick={() => {
                                        setBlockBooking(!blockBooking)
                                        setblockBookingModelClose(false)
                                    }} >No</button>
                                </section>
                            </div>
                        </div>
                    }
                </div>
                
            }
                    {EntityV2Store?.EntityRec?.razorpay && <div style={{ marginBottom: '6px' }}>
                        <RazorpayRize button={true} />
                    </div>}
                    {
                        <div class="columns is-vcentered is-multiline my-1">
                            <Col3>
                                <p><label>*Customer</label></p>
                                <input style={{ width: "90%", padding: "1% 2%", border: "1px solid #b6b5b5" }} value={contractsStore.current.entityName || e.entityName} disabled={true}>
                                </input>
                            </Col3>
                            <Col3 style={{ textAlign: "center", alignItems: "center" }}>
                                {/* <span onClick={()=>setIsNomination(!isNomination)}> */}
                                <span >
                                    <p>Nomination</p>
                                    {
                                        (contractsStore.current.nomination || e.nomination) ?
                                            <img height='36px' width='36px' src={on} ></img> :
                                            <img height='36px' width='36px' src={off}></img>
                                    }
                                </span>
                            </Col3>
                            <Col3>
                                <p><label>*Sales Person</label></p>
                                <input style={{ width: "90%", padding: "1% 2%", border: "1px solid #b6b5b5" }} value={contractsStore.current.salesperson || e.salesperson} disabled={true}>
                                </input>
                            </Col3>
                            <Col3>
                                <p><label>*Customer Service</label></p>
                                <input style={{ width: "90%", padding: "1% 2%", border: "1px solid #b6b5b5" }} value={contractsStore.current.customerService || e.customerService} disabled={true}>
                                </input>
                            </Col3>
                        </div>
                    }

            { (openDocModal && props.showbooking) &&
                        <div className='modal is-active' >
                            <div className="modal-background" ></div>
                                <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{ borderRadius: '10px' }} >
                                <section className="modal-card-body">
                                <h2 style={{ color: "black", textAlign:"center" }}>Document upload is available in the booking form. Do you want to continue with the action?</h2>
                                    <br></br>
                                    <button type="submit" class="button is-danger" style={{ float: "right" }}
                                        onClick={async (e)=>{
                                            e.preventDefault();
                                            EntityV2Api.checkMyactionEnt(bookingsStore.current.entityId ,bookingsStore.current.branchId , (data) => {
                                        if(data.status === 200) {
                                            taskStore.current = new Task('')
                                            taskStore.current.initialize(bookingsStore.current, entityStore.entityRec)
                                            taskStore.triggerActionVisible = true
                                          }
                                        })
                                            setOpenDocModal(false)
                                        }}
                                    >Proceed</button>
                                    <button class="button is-warning" onClick={() => {
                                        setOpenDocModal(false)
                                    }} >Cancel</button>
                                </section>
                            </div>
                        </div>
                    }
            <div className="columns">
                <div className="column is-12 m-0 p-0">
                <div className="w-full flex flex-col gap-[8px]">
       <form noValidate  style={{width:"100%",display:"flex",flexDirection:"column"}}>
       <div className="flex flex-row gap-[10px]">
        <div className="flex flex-col">  
       <Route form={cargoForm} viewonly={props.viewonly=='1'} callback={updatecusref} edit={(!props.showbooking && e.status !=='CANCELLED')?true:false}/>
       { props.showbooking === "1" && <button type="button" style={{ float: 'left', marginTop:"10px" }}
                                className="button is-rounded is-small islink" onClick={(e) => {
                                    e.stopPropagation();
                                    let customTC = []
                                    if (rec['customTC']) {
                                        customTC = rec['customTC'].split(/\r?\n/)
                                    }
                                    rec['tc']?.map(e => customTC.push(e))
                                    rec['temptc']?.map(e => customTC.push(e))
                                    configStore.setModalMessage("", [], false, customTC)
                                    // configStore.setModalMessage("hja")
                                }}>Terms and Conditions</button>}
        </div>
       <Details onIorPartyUpdate={(val)=>{
         MonApi.apost(UPDATE_BOOKING_FIELDS_URI, {
  _id: bookingsStore.current._id,
  'contract.iorParty': val
})
       }} form={cargoForm} viewonly={props.viewonly=='1'}/> 
    
       </div>
       </form>
       </div>
                </div>
                
                
            </div>
                    {props.showbooking &&
                        !loginStore.isClient() &&
                        bookingsStore.current &&
                        bookingsStore.current.contract && (
                            <ContractDetails
                                procurement={bookingsStore.current.contract.procurement}
                                formatProcurement={getpr}
                                cartingDetails={bookingsStore.current.contract.cartingDetails}
                                agentDetails={bookingsStore.current.contract.agentDetails}
                                agentAddress={bookingsStore.current.contract.agentAddress}
                                alignRight={false}
                                isAgentEditable={true}
                                renderAgentSearch={(hideRenderProps) => {
                                    return <div className="w-full">
                                        <Autocomplete
                                            value={agentEntity}
                                            freeSolo={true}
                                            size="small"
                                            disableClearable
                                            // filterOptions={(menuoptions, state) => menuoptions}
                                            getOptionLabel={(entity) => entity.entityName}
                                            onChange={(e, val) => {
                                                console.log(" the val is ",val)
                                                if(val && val.entityId){
                                                 setAgentEntity(val)
                                                 bookingsStore.current.contract.agentDetails = val.entityName;
                                                 bookingsStore.current.contract.agentEntityId = val.entityId;
                                                 hideRenderProps(false)
                                                 BranchApi.getAllBranches(val.entityId, (data)=>
                                                             { 
                                                                let address = "";
                                                                let mainBranch;
                                                                if(data && data[0]){
                                                                    mainBranch = data[0].branchAddresses[0];
                                                                    address = mainBranch.address + ", " + mainBranch.city + ", " + mainBranch.zipcode
                                                                     console.log(" the address is ",mainBranch)
                                                                }
                                                                bookingsStore.current.contract.agentAddress = address
                                                                // let address = mainBranch.
                                                                updateAgentDetails()
                                                             }
                                                             )
                                                }
                                                // setAutocompleteOpen(false);
                                            }}
                                            onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  }}
                                            // onInputChange={(e) => {
                                            //     //   console.log("the en ",e?.target.value)
                                            //     //   if (onInputChange) {
                                            //     //     onInputChange(e?.target.value);
                                            //     //   }
                                            // }}
                                            disablePortal
                                            options={EntityV2Store.list.filter((entity)=>entity.status !== "DEACTIVATED" && (entity.entityType === "Vendor" || entity?.customer?.isChannelPartner) && entity.entityCountry.toLowerCase()!=="india")}
                                            sx={{ width: "100%" }}
                                            renderInput={(params) => <CustomStyledTextField sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    "&.Mui-focused": {
                                                        fieldset: {
                                                            borderColor: `${process.env.REACT_APP_ENTERPRISE_COLOUR} !important`, // Default focused color
                                                        },
                                                    },
                                                    // "&.Mui-disabled":{
                                                    //   fieldset:{
                                                    //     backgroundColor:"#F3F3F3"
                                                    //   },
                                                    //   "& .MuiFormLabel-root": {
                                                    //     color: "black !important",
                                                    //   },
                                                    //   "& .MuiInputBase-input.Mui-disabled": {
                                                    //     color: "black !important",
                                                    //     WebkitTextFillColor: "black !important", // For WebKit browsers
                                                    //   },
                                                    // }
                                                }
                                            }} placeholder="Search agent" size="small" {...params} fullWidth />}
                                        />
                                    </div>
                                }}
                            />
                        )}

            {
                (props.showbooking && !loginStore.isClient() && bookingsStore.current.createdFromPricing && AgmodalStore.modalPage !== "ViewEnquiry-v3") ?
                    <BookingSchedule booking={bookingsStore.current} /> :
                    <></>
            }

            {
                (props.showbooking) ?
                    <div className="columns">
                        <div className="column is-12">
                            {
                                (new Date (bookingsStore.current.bookingDate) >= shipConsMigratDate)?
                                <CarrierWebView2v3 showbooking={props.showbooking} />:<CarrierWebView1v3 showbooking={props.showbooking} />
                            }
                        </div>
                    </div>
                    : <></>
            }
            {
                (e.status === 'CANCELLED') ? <div style={{ textAlign: 'center' }}>
                <strong>Reason:</strong> {e.reason}<br/>
                {e.remarks !== '' && (
                <span><strong>Remarks:</strong> {e.remarks}</span>
                )}                
                </div>
                : 
                (e?.agragareason !== '') && (
                <span><strong>Remarks:</strong> {e.agragareason}</span>
                )
                            
            }
            {
                (!props.showbooking) ?
                    (e.status !=='CANCELLED')?
                     <div className="columns">
                        <div className="column is-6">
                                                {
                                                    !routes?.length ?
                                                        <RoutesEmpty message={routesEmptyMessage} />
                                                        : <></>
                                                }
                                            </div>
                            <div className="column is-2">
                            {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.ENQUIRIES.CANCEL_ENQUIRY) && (
                                <button style={{ float: 'right' }} className="button is-danger is-small is-rounded" onClick={() => {
                                    configStore.quotationModalVisible4 = true;
                                    AgmodalStore.apiCall = false;
                                }}>
                                    Cancel Enquiry</button>
                            )}
                            </div>
                            <div className="column is-2">
                            {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.ENQUIRIES.GENERATE_QUOTATION_FROM_ENQUIRY) && (
                                <button style={{ float: 'right' }} onClick={async (e) => {
                                    
                                    const isValid = await trigger();
            if (isValid) {
                handleSubmit(getRoutes)(e)
            }
                                }}
                                    className="button is-small is-rounded islink">
                                    Quote Rates
                                </button>
                                )}
                            </div>
                            <div className="column is-2">
                            {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.ENQUIRIES.GENERATE_QUOTATION_FROM_ENQUIRY) && (
                                <button style={{ float: 'right' }} disabled={isButtonClicked} onClick={() => {
                                    setButtonClicked(true);
                                    configStore.setModalMessage('Generating quotation from enquiry')
                                    EnquiriesApi.updateToQuote(e._id, () => {
                                        quoteDataRec.intialize()
                                        Api.getQuote(e._id)
                                        AgmodalStore.pageVisible = false;
                                        changeCurrentMenu('Quotationv3')
                                        AgmodalStore.modalPage = 'Quotev3';
                                        AgmodalStore.pageVisible = true;
                                    })

                                }}
                                    className="button is-small is-rounded islink">
                                    Generate Quotation from this Enquiry
                                </button>
                                )}
                            </div>
                            
                        </div>:<></>
                    : <></>
            }

            {
                routes.length>0 && <>
                        <div ref={buttonRef} className="columns">
                                <div className="column is-12">
{ (filtersState.routes?.length>0) && <>
                                <div className="flex flex-row justify-end my-1 items-center">
                                 { filtersState.routes?.length>0 && <FiltersMenu showSortBy={activeProduct!=="AIR"}/>}                
                                                </div></>}

                                                                                                {
                                                                                                    activeProduct.toLowerCase().indexOf('lcl')!=-1 &&
                                                                                                   <>
                                                                                                      <SpotLCLDisplayv3 filteredRoutes={filtersState.routes} routes={filtersState.filteredList} getquote={true}
                                                                                                        />
                                                                                                       {filtersState.optionalFilteredList.length>0 && <div className="flex flex-col gap-2 mt-2 items-center">
                                                 { filtersState.filteredList?.length === 0 ? <>
                                                                        <p className="font-bold">No results found for your filter.</p>
                                                                        <p>But don’t worry — we’ve picked some suggested routes you might be interested in!</p>
                                                                     </> : <p>we’ve picked some suggested routes you might be interested in!</p> }
                                                                                                        <SpotLCLDisplayv3 filteredRoutes={filtersState.routes} routes={filtersState.optionalFilteredList} getquote={true}
                                                                                                        /> 
                                                                                                        </div>}
                                                                                                   </>
                                                                                                }
                                                                                                {
                                                                                                    activeProduct.toLowerCase().indexOf('fcl')!=-1 &&
                                                                                                    <>
                                                                                                      <SpotFCLDisplayv3 filteredRoutes={filtersState.routes} routes={filtersState.filteredList} getquote={true}
                                                                                                           />
                                                                                                       {filtersState.optionalFilteredList.length>0 && <div className="flex flex-col gap-2 mt-2 items-center">
                                                                                                              { filtersState.filteredList?.length === 0 ? <>
                                                                                                                                     <p className="font-bold">No results found for your filter.</p>
                                                                                                                                     <p>But don’t worry — we’ve picked some suggested routes you might be interested in!</p>
                                                                                                                                  </> : <p>we’ve picked some suggested routes you might be interested in!</p> }
                                                                                                        <SpotFCLDisplayv3 filteredRoutes={filtersState.routes} routes={filtersState.optionalFilteredList} getquote={true}
                                                                                                           /> 
                                                                                                        </div>}
                                                                                                    </>
                                                                                                }
                                </div>
                                </div>
                </>
            }

            {
                ((props.showbooking && graphList.length != 0)) ? <>
                    <hr />
                    <div>
                        <div className="box is-fullwidth">
                            {
                                graphList.map((e, i) => {
                                    let e1 = myactionsstore.list[i]
                                    return <VisibilityGraph graphNodes={e} dsrRec={e1} hideedit={false} />
                                })
                            }
                        </div>
                    </div>
                    {/* <h1 style={{textAlign:"center"}}><strong>DSR</strong></h1>
                    <ShipmentGraph graphNodes={graphList[0]} /> */}
                </> : <></>
            }
            </>
        }
        {
            configStore.quotationModalVisible && <DsrModal graphList={graphList} />
        }
        </>
    )
}

export function Costmodal(props) {
    useSnapshot(taskStore)
    console.log(props)
    let rec = props.rec
    let type = rec.shipmentType
    if(type!=undefined && type.indexOf("FCL") >= 0){
        type = "FCL"
    }
    let modalClass = 'modal'
    if (taskStore.costmodal) modalClass += ' is-active'
    return (
        <div className={modalClass} onClick={() => { taskStore.costmodal = false }}>
            <div className="modal-background" ></div>
            <div className="modal-card" onClick={(e) => { e.stopPropagation() }}
                style={{ borderRadius: '10px',width:"auto" }}>

                <dev className="modal-card-body" style={{ textAlign: 'center' }}>
                    <button className="delete" style={{ float: 'right' }}
                        onClick={() => { taskStore.costmodal = false }}></button>
                    <div>
                        {
                             (type.indexOf("FCL") >= 0)?<FCLChargeClientViewv3 dummyContract={rec}/> :<>
                             {
                                (type.indexOf("Air") >= 0)?<AirChargesClientViewv3 dummyContract={rec}/> :
                                <LCLChargeClientViewv3 dummyContract={rec}/> 
                             }
                             </>
                        }
                        <Taskfiledisplay notshow={true} validation={true} task={rec}/>
                    </div>
                </dev>
            </div>
        </div>
    )
}


function Cartingmodal() {
    useSnapshot(bookingsStore)
    useSnapshot(taskStore)
  let modalClass = "modal";
  if (configStore.cartingmodal) modalClass += " is-active";
  const [csref, setCsref] = useState("")
  const [data, setData] = useState({})
  const [cartinglist, setCartinglist] = useState({})
  useEffect(()=>{
    if(csref!=""){
        setCsref("")
    }
  },[configStore.cartingmodal])
  const getshippingbill = async (a)=>{
    let k = await MonApi.apost(GET_CARTING_ORDERS_WITHOUT_FILES_URI, {
  _id: a
})
    let k1 = {}
    k.map((v)=>{
        k1[v._id]= v.shippingBillNo
    })
    setCartinglist(k1)
  }
  useEffect(()=>{
    let a = []
    if(bookingsStore.current.cartingsheetId!=undefined && bookingsStore.current.cartingsheetId.length>0){
        a.push(bookingsStore.current.cartingsheetId)
    }
    if(bookingsStore.current.linkedCarting!=undefined && bookingsStore.current.linkedCarting.length>0){
        bookingsStore.current.linkedCarting.map((v)=>{a.push(v)})
    }
    if(a.length>0){
        getshippingbill(a)
    }
  },[JSON.stringify(bookingsStore.current)])
  const bookingcancel = ()=>{
    loader.show()
    console.log(data)
    if(data['cancelbooking'] && data['cancelbooking'].length>0){
        let booking = data['cancelbooking'][0]
        const cb = async ()=>{
            taskStore.current = new Task('')
            taskStore.current.initialize(booking, entityStore.entityRec)
            taskStore.current.actionName = "Request for Booking Cancellation"
            Object.assign(taskStore.current, getPayload("Request for Booking Cancellation"))
            taskStore.current.reason = "Booking is cancelled, as it is linked in the "+bookingsStore.current._id
            taskStore.current.entityId=booking.contract.entityId
            taskStore.current.branchId=booking.branchId
            taskStore.setCustomerComplete()
            taskStore.setComplete()
            taskStore.current.stage = 4
            taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
            taskStore.name = "Request for Booking Cancellation"
            taskStore.oldtask = JSON.parse(JSON.stringify(taskStore.current))
            await Taskapi.saveTaskRequestCancellation(taskStore.current,booking['_id'],booking)
            if (booking?._id != undefined) {
                await MonApi.apost(REMOVE_MYACTIONS_BY_BOOKING_NUMBER_AND_STATUS_URI, {
                    bookingNum: booking?._id,
                    status: 'PENDING'
                })
            }
            booking.status = "CANCELLED"
            booking.requestCancellationReason = "Booking is cancelled, as it is linked in the "+bookingsStore.current._id
            await Taskapi.replaceBooking(booking)
            let callback1 = async (d)=>{
                let b = await MonApi.apost(GET_BOOKINGS_LIST_URI, {
  _id: bookingsStore.current._id
})
                if(b.length>0){
                    bookingsStore.current = JSON.parse(JSON.stringify(b[0]))
                    contractsStore.current = b[0].contract
                    contractsStore.current = new QuoteCalcV2(contractsStore.current).recalc()
                    enquiryStore.initializeWithConract(b[0].contract)
                }
                loader.hide()
                configStore.setModalMessage('Carting Sheet Linked successfully.')
                setCsref("")
            }
            CartingOrderApi.ClaimCartingorder({id:data['_id'],bookingId:bookingsStore.current._id},callback1)
        }
        cb()
    } else {
        let callback1 = async (d)=>{
            let b = await MonApi.apost(GET_BOOKINGS_LIST_URI, {
  _id: bookingsStore.current._id
})
            if(b.length>0){
                bookingsStore.current = JSON.parse(JSON.stringify(b[0]))
                contractsStore.current = b[0].contract
                contractsStore.current = new QuoteCalcV2(contractsStore.current).recalc()
                enquiryStore.initializeWithConract(b[0].contract)
            }
            loader.hide()
            configStore.setModalMessage('Carting Sheet Linked successfully.')
            setCsref("")
        }
        CartingOrderApi.ClaimCartingorder({id:data['_id'],bookingId:bookingsStore.current._id},callback1)
    }
  }
  const checkcarting = ()=>{
    loader.show()
    if(csref!=undefined && csref.length==0){
        loader.hide()
        configStore.setModalMessage('Carting Sheet Ref should not save as empty')
        return;
    }
    const callback = (d)=>{
        if(d['msg'].length>0){
            if(d['msg'].indexOf('proceed')==-1 && d['msg'].indexOf('Proceed')==-1){
                loader.hide()
                configStore.setModalMessage(d['msg'])
            }else{
                loader.hide()
                setData(d)
                configStore.hasToShowAgWarn = true
            }
        }else{
            let callback1 = async (d)=>{
                let b = await MonApi.apost(GET_BOOKINGS_LIST_URI, {
  _id: bookingsStore.current._id
})
                if(b.length>0){
                    bookingsStore.current = JSON.parse(JSON.stringify(b[0]))
                    contractsStore.current = b[0].contract
                    contractsStore.current = new QuoteCalcV2(contractsStore.current).recalc()
                    enquiryStore.initializeWithConract(b[0].contract)
                }
                loader.hide()
                configStore.setModalMessage('Carting Sheet Linked successfully.')
                setCsref("")
            }
            CartingOrderApi.ClaimCartingorder({id:d['_id'],bookingId:bookingsStore.current._id},callback1)
        }
        
    }
    CartingOrderApi.Checkcarting({id:csref,bookingId:bookingsStore.current._id},callback)
  }
  return (
    <>
    <AgWarnPopup data={bookingcancel} acceptBtnText="Proceed">
        {data?.stuffedRefs && data.stuffedRefs.length > 0 ? (
            <div style={{ textAlign: "left" }}>
                <div style={{ fontWeight: "700", fontSize: "14px", color: "#1e3a8a", marginBottom: "8px" }}>
                    Shipment Confirmation
                </div>

                {data?.cancelbooking && data.cancelbooking.length > 0 && (
                    <div style={{
                        backgroundColor: "#fef2f2",
                        border: "1px solid #fca5a5",
                        borderRadius: "6px",
                        padding: "8px 10px",
                        fontSize: "12px",
                        color: "#991b1b",
                        marginBottom: "10px"
                    }}>
                        <strong>Note:</strong> This Carting Sheet is already linked to <strong>Booking #{data.cancelbooking[0]._id}</strong>. Proceeding will cancel that booking and re-link the Carting Sheet to this booking.
                    </div>
                )}

                <div style={{ fontSize: "12px", color: "#334155", marginBottom: "6px" }}>
                    The following shipment(s) are in active/non-standard planning status:
                </div>
                <div style={{
                    backgroundColor: "#fffbeb",
                    border: "1px solid #fef3c7",
                    borderRadius: "6px",
                    padding: "8px 10px",
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#92400e",
                    marginBottom: "8px"
                }}>
                    {data.stuffedRefs.map((ref, idx) => (
                        <div key={idx}>{ref}</div>
                    ))}
                </div>
                <div style={{ fontSize: "12px", color: "#334155" }}>
                    Are you sure you want to proceed with linking these shipment(s)?
                </div>
            </div>
        ) : (
            <p className="is-size-7 notification is-warning">{data?.msg}</p>
        )}
    </AgWarnPopup>
    
    <div className={modalClass}>
      <div className="modal-background"></div>
      <div
        className="modal-card"
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={{ borderRadius: "10px", width: "900px" }}
      >
        <section className="modal-card-body">
            <button className="delete" style={{ float: 'right' }}
                        onClick={() => { configStore.cartingmodal = false }}></button>
                        <br />
                        <div className="columns ">
                {
                    (["INPROGRESS", "SUBMITTED"].indexOf(bookingsStore.current.status) != -1 && !bookingsStore.current.cargoOnHold) &&<><div className="column is-4" >
                    <div className="control is-fullwidth">
                <input className="input is-small" value={csref} onChange={(e)=>{
                    setCsref(e.target.value)
                }} placeholder="Carting Sheet # (Or) Shipping Bill No" />
                </div>
                </div>
                <div className="column is-2" >
                    <button className="button is-small islink"
                                        onClick={() => {
                                            checkcarting()
                                        }}>
                                        Linked
                                    </button>
                </div></>
                }
                
                </div>
            <table>
        <tbody>
            {(bookingsStore.current.cartingsheetId!=undefined && bookingsStore.current.cartingsheetId.length>0)?
            <><tr>
                <td>
                    <strong>Claimed Carting</strong>
                </td>
            </tr>
            <tr>
                <td>
                    {bookingsStore.current.cartingsheetId}{cartinglist[bookingsStore.current.cartingsheetId]!=undefined?` - ${cartinglist[bookingsStore.current.cartingsheetId]}`:""}
                </td>
            </tr></>:""
            
            } {(bookingsStore.current.linkedCarting!=undefined && bookingsStore.current.linkedCarting.length>0)?
                <>
                <tr>
                <td>
                    <strong>Linked Carting</strong>
                </td>
            </tr>
            {
                bookingsStore.current.linkedCarting.map((v)=>{
                    return <tr>
                <td>
                    {v}{cartinglist[v]!=undefined?` - ${cartinglist[v]}`:""}
                </td>
            </tr>
                })
            }
                </>:""
            }
        </tbody>
    </table>
        </section>
      </div>
    </div>
    </>
  );
}

function ShippingBillmodal() {
    useSnapshot(bookingsStore)
  let modalClass = "modal";
  if (configStore.shippingbillmodal) modalClass += " is-active";
  const [shippingbill, setShippingbill] = useState("")
  useEffect(()=>{
    if(shippingbill!=""){
        setShippingbill("")
    }
  },[configStore.shippingbillmodal])
  return (
    <div className={modalClass}>
      <div className="modal-background"></div>
      <div
        className="modal-card"
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={{ borderRadius: "10px", width: "900px" }}
      >
        <section className="modal-card-body">
            <button className="delete" style={{ float: 'right' }}
                        onClick={() => { configStore.shippingbillmodal = false }}></button>
                        <br />
                        <div className="columns ">
                <div className="column is-4" >
                    <div className="control is-fullwidth">
                <input className="input is-small" value={shippingbill} onChange={(e)=>{
                    setShippingbill(e.target.value)
                }} placeholder="Shipping Bill No" />
                </div>
                </div>
                <div className="column is-2" >
                    <button className="button is-small islink"
                                        onClick={async () => {
                                            try {
                                                loader.show()
                                                if(shippingbill!=undefined && shippingbill.length==0){
                                                    loader.hide()
                                                    configStore.setModalMessage('Shipping Bill No should not save as empty')
                                                    return;
                                                }
                                                let isBookingExistsWithSame = await MonApi.apost(GET_CARTING_ORDERS_BY_FILTER_URI, {
  shippingBillNo: shippingbill,
  status: "Carted"
})
                                                console.log("isBookingExistsWithSame",isBookingExistsWithSame)
                                                let callback = async (d)=>{
                                                    let b = await MonApi.apost(GET_BOOKINGS_LIST_URI, {
  _id: bookingsStore.current._id
})
                                                    if(b.length>0){
                                                        bookingsStore.current = JSON.parse(JSON.stringify(b[0]))
                                                        contractsStore.current = b[0].contract
                                                        enquiryStore.initializeWithConract(b[0].contract)
                                                    }
                                                    loader.hide()
                                                    configStore.setModalMessage('Shipping Bill No Added successfully.')
                                                    setShippingbill("")
                                                }
                                                if (isBookingExistsWithSame.length>0) {
                                                    CartingOrderApi.ClaimCartingorder({id:isBookingExistsWithSame[0]['_id'],bookingId:bookingsStore.current._id},callback)
                                                }else{
                                                    CartingOrderApi.ClaimCartingorder({shippingBillNo:shippingbill,bookingId:bookingsStore.current._id},callback)
                                                }
                                            } catch (e) {
                                                loader.hide()
                                                configStore.setModalMessage('Error trying to save Carting Sheet Ref #')
                                            }
                                        }}>
                                        Add
                                    </button>
                </div>
                </div>
            <table>
        <tbody>
            {(bookingsStore.current.shippingBillNo!=undefined && bookingsStore.current.shippingBillNo.length>0)?
                <>
                <tr>
                <td>
                    <strong>Shipping Bill No</strong>
                </td>
            </tr>
            {
                bookingsStore.current.shippingBillNo.map((v)=>{
                    return <tr>
                <td>
                    {v}
                </td>
            </tr>
                })
            }
                </>:""
            }
        </tbody>
    </table>
        </section>
      </div>
    </div>
  );
}